import { type PlatformReturnType, PlatformType } from './Products.types'

export const PLATFORM_MAP: Record<PlatformReturnType, PlatformType> = {
  waas: PlatformType.WAAS,
  mobile: PlatformType.MOBILE,
}
